import type { IconProps } from "@models/types";
import { SVGAttributes } from "react";

export function LeftChevron(props: SVGAttributes<SVGAElement>) {
  return (
    <svg
      {...props}
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
    >
      <path d="M14.24,19.63c.29,0,.59-.11,.81-.34,.45-.45,.45-1.18,0-1.62L6.57,9.2c-.45-.45-1.18-.45-1.62,0-.45,.45-.45,1.18,0,1.62l8.47,8.48c.22,.22,.52,.34,.81,.34Z" />
      <path d="M5.76,11.14c.29,0,.59-.11,.81-.34L15.05,2.33c.45-.45,.45-1.18,0-1.62-.45-.45-1.18-.45-1.62,0L4.95,9.18c-.45,.45-.45,1.18,0,1.62,.22,.22,.52,.34,.81,.34Z" />
    </svg>
  );
}
